import { RouteRecordRaw } from "vue-router";

import usePermissions from "@/hooks/use-permissions";
import FeatureFormPage from "@/pages/games/GameDisplay/children/features/FeatureForm/FeatureFormPage.vue";
import FeaturesListPage from "@/pages/games/GameDisplay/children/features/FeaturesList/FeaturesListPage.vue";
import PaymentFeatureFormPage from "@/pages/games/GameDisplay/children/features/PaymentFeatureForm/PaymentFeatureFormPage.vue";

import links from "./links";

const { canReadFeatures, canWriteFeatures } = usePermissions();

export default <RouteRecordRaw[]>[
  {
    path: ":featureId/edit",
    component: FeatureFormPage,
    name: links.games.features.edit,
    props: (route) => ({ ...route.params, edit: true }),
    meta: {
      title: "Edit metric",
      permission: canWriteFeatures,
    },
  },
  {
    path: ":featureId/preview",
    component: FeatureFormPage,
    name: links.games.features.preview,
    props: (route) => ({ ...route.params, preview: true }),
    meta: {
      title: "Preview metric",
      permission: canReadFeatures,
    },
  },
  {
    path: "create",
    component: FeatureFormPage,
    name: links.games.features.create,
    props: true,
    meta: {
      title: "Create metric",
      permission: canWriteFeatures,
    },
  },
  {
    path: ":featureId/edit-payment",
    component: PaymentFeatureFormPage,
    name: links.games.features.editPayment,
    props: (route) => ({ ...route.params, edit: true }),
    meta: {
      title: "Edit payment metric",
      permission: canWriteFeatures,
    },
  },
  {
    path: ":featureId/preview-payment",
    component: PaymentFeatureFormPage,
    name: links.games.features.previewPayment,
    props: (route) => ({ ...route.params, preview: true }),
    meta: {
      title: "Preview payment metric",
      permission: canReadFeatures,
    },
  },
  {
    path: "create-payment",
    component: PaymentFeatureFormPage,
    name: links.games.features.createPayment,
    props: true,
    meta: {
      title: "Create Payment metric",
      permission: canWriteFeatures,
    },
  },
  {
    path: "",
    component: FeaturesListPage,
    name: links.games.features.list,
    props: true,
    meta: {
      title: "Metrics",
      permission: canReadFeatures,
    },
  },
];
